import { maxBy, property, sortBy } from "lodash";
import { createSelector } from "reselect";

import { IStoreState } from "interfaces/storeState";
import { createRequestErrorSelector, createRequestFetchingSelector } from "store/requests/selectors";

import { IEntityCollectionState } from "../reducer";

import { RulesRequestSelectorsNames } from "./actions";
import { IRule } from "./interfaces";

export interface IWithRulesState {
  entities: {
    rules: IEntityCollectionState<IRule>;
  };
}

export const selectRuleCreateError = (state: IStoreState): string =>
  createRequestErrorSelector([RulesRequestSelectorsNames.CREATE_RULE_REQUEST])(state);

export const selectRuleCreateLoading = (state: IStoreState): boolean =>
  createRequestFetchingSelector(["CREATE_RULES"])(state);

export const selectRulesFetchLoading = (state: IStoreState): boolean =>
  createRequestFetchingSelector([RulesRequestSelectorsNames.FETCH_RULES_COLLECTION_REQUEST])(state);

export const selectRulesUpdateError = (state: IStoreState): string =>
  createRequestErrorSelector([RulesRequestSelectorsNames.UPDATE_RULE_REQUEST])(state);

export const selectRulesUpdateLoading = (state: IStoreState): boolean =>
  createRequestFetchingSelector(["UPDATE_RULES"])(state);

const selectRawRules = (state: IWithRulesState): IEntityCollectionState<IRule> => state.entities.rules;

export const selectRules = createSelector(selectRawRules, rules => sortBy(Object.values(rules), property("ordering")));

export const selectActiveRules = createSelector(selectRules, rules => rules.filter(rule => rule.active));

export const selectRulesMaxOrdering = createSelector(
  selectRules,
  rules => maxBy(rules, rule => rule.ordering)?.ordering || 0
);
